import camelCase from 'lodash/camelCase'
import { savePaginator } from '../reducers/pager'
import isEqual from 'lodash/isEqual'

// const API_URL = 'http://localhost:8080/api/v1'
const API_URL = process.env.REACT_APP_API_URL

const apiListAction = (data) => {
    if (data.length > 0 && '_key' in data[0]) {
        // if (data.length > 0) {
        // return { type: 'facilities/genericSingleAction', data }
        // return { type: `SAVE_${data[0]._key}_LIST`, data }
        return { type: `${data[0]._key.toUpperCase()}/listAction`, data }
    }
    return { type: null }
}

const apiSingleAction = (data) => {
    if (data && '_key' in data) {
        const actionType = `${data._key.toUpperCase()}/singleAction`
        return { type: actionType, data }
    }
    return { type: null }
}

const apiRemoveAction = (data) => {
    if (data && '_key' in data) {
        const actionType = `${data._key.toUpperCase()}/removeItem`
        return { type: actionType, data }
        // return { type: `REMOVE_${data._key}`, data }
    }
    return { type: null }
}

const managePagination = (paginator) => {
    return dispatch => {
        if ('_key' in paginator) {
            const pagerKey = camelCase(paginator._key)
            delete paginator._key
            dispatch(savePaginator({
                key: pagerKey,
                data: paginator
            }))
        }
    }
}

const buildURLParams = (params) => {
    let query = ''
    query = Object.keys(params).map(key => {
        if (Array.isArray(params[key])) {
            return params[key].map(ad => {
                return encodeURIComponent(key) + '[]=' + encodeURIComponent(ad)
            }).join('&')
        } else if (typeof params[key] === 'object') {
            return Object.keys(params[key]).map(nestedKey => {
                if (Array.isArray(params[key][nestedKey])) {
                    return params[key][nestedKey].map(nad => {
                        return encodeURIComponent(key) + `[${nestedKey}][]=` + encodeURIComponent(nad)
                    }).join('&')
                }
                return encodeURIComponent(key) + `[${nestedKey}]=` + encodeURIComponent(params[key][nestedKey])
            }).join('&')
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&')
    if (query !== '') {
        query = '?' + query
    }
    return query
}

export const fetchApiData = (routeObj, params = {}, directReturn = false) => {
    return dispatch => {
        let query = buildURLParams(params)
        const apiUrl = `${API_URL}${routeObj.url}${query}`
        return fetch(apiUrl, {
            method: routeObj.method,
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => Promise.all([response, response.json()]))
            .then(([response, result]) => {
                if (response.ok) {
                    if (routeObj.method === 'DELETE') {
                        return dispatch(apiRemoveAction(result.data))
                    } else if (directReturn) {
                        return result.data
                    }
                    if ('pager' in result && result.pager) {
                        dispatch(managePagination(result.pager))
                    }
                    return dispatch(manageApiData(result.data))
                }
                alert('Error:', result)
                return dispatch(null)
            })
            .catch(error => {
                console.error('API Error:', error)
            })
    }
}

export const manageApiData = (data, updateObj = {}, depth = 0) => {
    let uObj = { ...updateObj }
    if (!data || (Array.isArray(data) && data.length === 0)) {
        if (depth === 0) {
            return dispatch => {
                return { type: null }
            }
        }
        return updateObj
    } else if (Array.isArray(data)) {
        data.forEach(item => {
            if (item && '_related' in item) {
                Object.keys(item._related).forEach(relation => {
                    let relatedObj = manageApiData(item._related[relation], uObj, depth + 1)
                    uObj = { ...relatedObj }
                })
            }
            let myObj = checkForObjEquality(item, uObj)
            uObj = { ...myObj }
        })
        if (depth > 0) {
            return uObj
        }
    } else {
        if ('_related' in data) {
            Object.keys(data._related).forEach(relation => {
                let relatedObj = manageApiData(data._related[relation], uObj, depth + 1)
                uObj = { ...relatedObj }
            })
        }

        let myObj = checkForObjEquality(data, uObj)
        uObj = { ...myObj }
        if (depth > 0) {
            return uObj
        }
    }
    if (depth === 0) {
        return dispatch => {
            Object.keys(uObj).forEach(updateKey => {
                if (uObj[updateKey].length === 1) {
                    dispatch(apiSingleAction(uObj[updateKey][0]))
                } else {
                    dispatch(apiListAction(uObj[updateKey]))
                }
            })
        }
    }
    return uObj
}

const checkForObjEquality = (data, updateObj) => {
    if (!('_key' in data)) {
        return updateObj
    }
    let key = data._key
    let dataCopy = { ...data }
    let objCopy = { ...updateObj }
    delete dataCopy._related
    if (key in objCopy) {
        let match = false
        objCopy[key].forEach(keyData => {
            if (match) {
                return
            }
            // remove the related from the objs
            if (isEqual(keyData, dataCopy)) {
                match = true
                return
            }
        })
        if (!match) {
            objCopy[key].push(dataCopy)
        }
    } else {
        objCopy[key] = [dataCopy]
    }
    return objCopy
}
